(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-carousel')) {
    class AnnouncementCarousel extends HTMLElement {
      constructor() {
        super();
        this.currentIndex = 0;
        this.timer = null;
      }

      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.prevButton = this.querySelector('[data-carousel-prev]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        if (this.slides.length === 0) return;

        this.mode = this.dataset.transition === 'slide' ? 'slide' : 'fade';
        this.autoplay = this.dataset.autoplay === 'true';
        this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
        this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.goTo(0, false);

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => {
            this.goTo(this.currentIndex - 1);
            this.restartAutoplay();
          });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => {
            this.goTo(this.currentIndex + 1);
            this.restartAutoplay();
          });
        }

        if (this.slides.length > 1 && this.autoplay) {
          this.startAutoplay();

          if (this.pauseOnHover) {
            this.addEventListener('mouseenter', () => this.stopAutoplay());
            this.addEventListener('mouseleave', () => this.startAutoplay());
          }

          this.addEventListener('focusin', () => this.stopAutoplay());
          this.addEventListener('focusout', () => this.startAutoplay());

          this.visibilityHandler = () => {
            if (document.hidden) {
              this.stopAutoplay();
            } else {
              this.startAutoplay();
            }
          };
          document.addEventListener('visibilitychange', this.visibilityHandler);
        }
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.visibilityHandler) {
          document.removeEventListener('visibilitychange', this.visibilityHandler);
        }
      }

      goTo(index, animate = true) {
        const total = this.slides.length;
        this.currentIndex = (index + total) % total;

        this.slides.forEach((slide, i) => {
          const isActive = i === this.currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          const link = slide.querySelector('a');
          if (link) link.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        if (this.mode === 'slide' && this.track) {
          this.track.style.transition = animate && !this.reducedMotion ? '' : 'none';
          this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
        }
      }

      startAutoplay() {
        if (this.slides.length <= 1 || !this.autoplay) return;
        this.stopAutoplay();
        this.timer = setInterval(() => this.goTo(this.currentIndex + 1), this.autoplaySpeed);
      }

      stopAutoplay() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }

      restartAutoplay() {
        if (this.autoplay) this.startAutoplay();
      }
    }

    customElements.define('announcement-carousel', AnnouncementCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
